import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/service/auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-central-dashboard',
  templateUrl: './central-dashboard.component.html',
  styleUrls: ['./central-dashboard.component.scss']
})
export class CentralDashboardComponent implements OnInit {
  token: any;

  constructor(private router: Router, private api: AuthService) {
    if (localStorage.getItem(environment.tokenKey)) {
      // this.token = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).token
      this.api.getUserData({}).subscribe((res: any) => {
        if (res.success) {
          this.token = res.data
          if (!this.token.permissions.centraldashboard) {
            this.router.navigate(['dashboard']);
            return
          }
        } else {

        }
      })
    }
  }

  ngOnInit(): void {
  }

  showStepSecond(type) {
    this.router.navigate(['dashboard', { 'param': 'central' }])
  }
}
